define( function() {

"use strict";

// https://www.w3.org/TR/css3-selectors/#whitespace
return "[\\x20\\t\\r\\n\\f]";

} );



//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/src/var/whitespace.js
// module id = BOY4
// module chunks = 7